export default {
  name: "dr-dice-choice",
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dices: [1, 2, 3, 4, 5, 6],
      selectedDice: 1
    };
  },
  mounted() {
    this.$on("input", function(event) {
      this.selectedDice = parseInt(event);
    });
  },
  computed: {
    inputListeners: function() {
      var vm = this;

      return Object.assign({}, this.$listeners, {
        input: function(event) {
          vm.$emit("input", event.target.value);
        }
      });
    }
  }
};
